import classNames from "classnames";

import {Button} from "@/components/button/Button.tsx";
import {Chip} from "@/components/chip/Chip.tsx";
import {Dot} from "@/components/dot/Dot.tsx";
import {
  NavTabsBadgeVariant,
  NavTabsButtonTypography,
  NavTabsButtonVariant,
  NavTabsProps,
} from "@/components/navTabs/NavTabs.types.ts";

import styles from "./NavTabs.module.scss";

export const NavTabs = ({className, items, selectedId, selectTab, variant = "default"}: NavTabsProps) => (
  <div className={classNames(styles.navTab, styles[variant], className)} role="tablist">
    {items.map(({id, title, badgeText, error}, idx) => (
      <Button
        key={`${idx}-${id}`}
        variant={NavTabsButtonVariant[variant]}
        typography={NavTabsButtonTypography[variant][selectedId === id ? 1 : 0]}
        onClick={() => selectTab(id)}
        role="tab"
        aria-current="page"
        className={classNames(styles.tab, {active: selectedId === id})}
      >
        {title}
        {badgeText !== undefined && badgeText !== 0 && badgeText !== "0" && (
          <Chip variant={NavTabsBadgeVariant[variant][selectedId === id ? 1 : 0]} size={"tiny"} className="ms-1">
            {badgeText}
          </Chip>
        )}
        {error && <Dot className={styles.errorIndicator} aria-label={`Tab ${id} has errors`} variant="red" />}
      </Button>
    ))}
  </div>
);
